import { Navigate, useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import JsonLD from "@/components/base/JsonLD";

export const blogArticles = [
  {
    slug: "kredyt-w-sierpniu-2026-od-czego-zaczac",
    title: "Kredyt w sierpniu 2026: od czego zacząć, zanim pójdziesz do banku",
    description: "Prosty plan przygotowania do kredytu: bez presji, zgadywania i zbędnych zapytań w bankach.",
    date: "2026-08-01",
    label: "Praktyczny start",
    body: [
      "Zanim zaczniesz porównywać oferty, uporządkuj swoją sytuację: dochody, raty, limity na kartach i planowany wkład własny. Dzięki temu rozmowa o finansowaniu jest konkretna od pierwszego spotkania.",
      "Nie wysyłaj wielu wniosków na próbę. Najpierw sprawdź zdolność, koszty całego kredytu oraz warunki wcześniejszej spłaty. Dopiero potem wybierz banki, w których oferta faktycznie pasuje do Twojego planu.",
      "Warto mieć też rezerwę na koszty poza ceną nieruchomości: wycenę, ubezpieczenie, opłaty sądowe i urządzenie mieszkania. Dobra decyzja kredytowa zostawia miejsce na normalne życie po podpisaniu umowy.",
    ],
  },
  {
    slug: "stala-czy-zmienna-rata",
    title: "Stała czy zmienna rata? Jak podjąć decyzję spokojnie",
    description: "Trzy pytania, które pomagają dopasować rodzaj oprocentowania do budżetu, a nie odwrotnie.",
    date: "2026-08-05",
    label: "Rata kredytu",
    body: [
      "Stała rata daje przewidywalność w okresie obowiązywania stałej stopy. Zmienna może reagować na sytuację rynkową, więc jej koszt w czasie jest mniej pewny. Nie ma jednego rozwiązania dla wszystkich.",
      "Zadaj sobie trzy pytania: czy budżet udźwignie wzrost raty, jak długo planujesz utrzymać kredyt i czy cenisz stabilność bardziej niż możliwość zmiany kosztu. Odpowiedzi są ważniejsze niż sama nazwa produktu.",
      "Przed decyzją porównaj nie tylko ratę z pierwszego miesiąca. Sprawdź warunki po okresie stałej stopy, marżę, prowizję oraz możliwość nadpłaty. To pozwala wybrać wariant świadomie.",
    ],
  },
  {
    slug: "jak-zwiekszyc-zdolnosc-kredytowa",
    title: "7 sposobów na wyższą zdolność kredytową",
    description: "Praktyczne działania, które mogą poprawić zdolność kredytową przed złożeniem wniosku.",
    date: "2026-08-10",
    label: "Zdolność kredytowa",
    body: [
      "Zdolność nie zależy wyłącznie od pensji. Bank bierze pod uwagę także obecne raty, limity w kartach, liczbę osób w gospodarstwie domowym, formę zatrudnienia i historię spłat.",
      "Najczęściej pomaga: spłata drobnych zobowiązań, zamknięcie nieużywanych limitów, uporządkowanie historii wpływów i przygotowanie pełnych dokumentów dochodowych. Warto zrobić to przed złożeniem wniosku.",
      "Nie warto podejmować pozornych działań tylko po to, by podnieść wynik. Dobrze przygotowana analiza pokazuje, które kroki mają sens w Twojej sytuacji i kiedy bezpiecznie rozpocząć proces.",
    ],
  },
] as const;

export default function ArticlePage() {
  const { slug } = useParams();
  const article = blogArticles.find((item) => item.slug === slug);
  if (!article) return <Navigate to="/404" replace />;

  const url = `https://kredytpodkarpacie.pl/blog/${article.slug}`;
  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    description: article.description,
    datePublished: article.date,
    dateModified: article.date,
    inLanguage: "pl-PL",
    mainEntityOfPage: url,
    author: { "@type": "Person", name: "Jan Wojdyła" },
    publisher: { "@type": "Organization", name: "EXPERT KREDYTOWY", url: "https://kredytpodkarpacie.pl" },
  };

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <JsonLD data={schema} />
      <Navbar />
      <main className="flex-1 pt-28 md:pt-32 px-4 md:px-8 pb-14">
        <article className="max-w-3xl mx-auto bg-white border border-background-200 rounded-2xl shadow-sm p-6 md:p-10">
          <Breadcrumb />
          <p className="text-xs font-extrabold tracking-widest uppercase text-primary-600 mb-3">{article.label}</p>
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-foreground-950 leading-tight">{article.title}</h1>
          <p className="mt-4 text-sm text-foreground-500">Jan Wojdyła · {article.date}</p>
          <div className="mt-8 space-y-5 text-base leading-8 text-foreground-700">
            {article.body.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          </div>
          <a href="/kontakt" className="inline-flex mt-8 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold hover:bg-primary-600">Umów bezpłatną konsultację</a>
        </article>
      </main>
      <Footer />
    </div>
  );
}
